import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import tr from "@/i18n/tr";

export default function Forbidden() {
    return (
        <div className="animate-fade-in">
            <div className="relative overflow-hidden rounded-3xl border border-border bg-card p-10 md:p-16">
                <div aria-hidden className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[hsl(var(--destructive))]/10 blur-3xl" />
                <div className="relative flex flex-col items-center text-center gap-5 max-w-xl mx-auto">
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[hsl(var(--destructive))]/10 text-[hsl(var(--destructive))]">
                        <ShieldAlert className="h-8 w-8" />
                    </div>
                    <div>
                        <h1 className="text-3xl md:text-4xl font-bold tracking-tight">{tr.forbidden.title}</h1>
                        <p className="mt-3 text-muted-foreground text-[15px]">{tr.forbidden.body}</p>
                    </div>
                    <Link to="/dashboard" className="btn-brand">
                        {tr.sidebar.dashboard}&apos;ne dön
                    </Link>
                </div>
            </div>
        </div>
    );
}
